import BaseTabContainer from "components/base/BaseTabContainer";
import { CustomDropGroup } from "components/base/CustomDropGroup";
import { ImageButton } from "components/base/CustomImageButton";
import { CustomTitleLabel } from "components/earning/CustomBaseComponments";
import { COUPON_STORE_GROUP_BY_TYPE } from "config/CustomEnums";
import React from "react";
import { connect } from "react-redux";
import { capitalizeFirstLetter } from "utils/StringUtil";
import CloseIcon from 'assets/images/close.svg';
import { ProcessEnvConfig } from "config/ProcessEnvConfig";

const StoreGroupBy = [
  {
    label: 'Store category',
    type: 'storeCategory',
    displayTitle: 'Group by category',
    value: COUPON_STORE_GROUP_BY_TYPE.STORE_CATEGORY,
    namespace: 'storeCategoryList',
    key: 'filterStoreCategory',
  },
  {
    label: 'Brand',
    type: 'brand',
    displayTitle: 'Group by brand',
    value: COUPON_STORE_GROUP_BY_TYPE.BRAND,
    namespace: 'brand',
    key: 'filterStoreBrand',
  },
...(ProcessEnvConfig.haveShopMall
    ? [
      {
        label: 'Mall',
        type: 'mall',
        displayTitle: 'Store grouped by mall',
        value: COUPON_STORE_GROUP_BY_TYPE.MALL,
        namespace: 'mall',
        key: 'filterStoreMall',
      },
    ]
    : []),
];

const GroupedStoresDisplaySection = ({
  hideSummaryTitle=false,
  isPreview = false,
  allSelectedStores,
  allGroupedCouponStores,
  removeOneStoreAction = () => { },
  removeGroupedStoreAction = () => { },
}) => {
  const sortedStores = allSelectedStores?.sort((a, b) => {
    const primaryComparison = a.name.localeCompare(b.name);
    if (primaryComparison !== 0) {
      return primaryComparison;
    }
    return a.id - b.id;
  })
  const getGroupedStores = () => {
    let res = {}
    StoreGroupBy.forEach((groupConfig) => {
      const groupKey = `groupBy${capitalizeFirstLetter(groupConfig.type)}`
      const groupData = allGroupedCouponStores?.[groupKey]
      if (!sortedStores?.length > 0) {
        res[groupKey] = []
        return
      }
      res[groupKey] = groupData?.map(data => ({
        ...data, stores: data?.stores?.filter(s => selectedStoreIds?.includes(s?.pk || s?.id))
      })).filter(v => v?.stores?.length > 0)
    })
    return res
  }
  const selectedStoreIds = sortedStores?.map(item => item?.pk || item?.id);

  const groupedStores = getGroupedStores();

  return (
    <>
      {hideSummaryTitle ? null: <CustomTitleLabel
        title={`Summary of selected stores (${sortedStores?.length || 0})`}
        className={'create-section-label-no-top-space'}
      />}
      <div
        className={`selected-store-filter-area store-result ${sortedStores?.length > 0 ? "" : "empty-list"}`}
      >
        <BaseTabContainer
          tabs={
            [
              {
                name: "Sort by name",
                content: (
                  <ul className="sorted-stores-container">
                    {sortedStores?.map(store => (
                      <li >
                        <div className="store-line-with-close">
                          {`[ID: ${store?.pk || store?.id || "-"}]${store.isOnlineStore ? '[Online]' : ''} ${store?.name || "-"}`}
                          {!isPreview &&
                            <ImageButton
                              image={CloseIcon}
                              className={'img-size-20'}
                              action={() => {
                                removeOneStoreAction(store?.pk || store?.id)
                              }}
                            />}

                        </div>
                      </li>
                    ))}
                  </ul>
                ),
              },
              ...StoreGroupBy.map((groupBy) => ({
                name: groupBy.displayTitle,
                content: (
                  <CustomDropGroup
                    defalutShowAll={true}
                    disabled={isPreview}
                    type={groupBy.type}
                    data={
                      groupedStores?.[
                      `groupBy${capitalizeFirstLetter(groupBy.type)}`
                      ]
                    }
                    getItemLabel={(store)=>
                      `[ID: ${store.id}]${store.isOnlineStore ? '[Online]' : ''} ${store.name}${store?.visibleInFrontEnd ? '' : ' (closed)'}`
                    }
                    action={isPreview ? () => { } : removeGroupedStoreAction}
                  />
                ),
              }))
            ]
          }
        />
      </div>
    </>
  )
}


const mapPropsToState = (state) => ({
});

export default  connect(mapPropsToState)(GroupedStoresDisplaySection);